/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type { SearchMonitorsMutationRequest, SearchMonitorsMutationResponse, SearchMonitors401 } from '../types/SearchMonitors.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getSearchMonitorsUrl() {
  const res = { method: 'POST', url: `/v1/monitors/search` as const };
  return res;
}

/**
 * @summary Search monitors
 * {@link /v1/monitors/search}
 */
export async function searchMonitors(
  data: SearchMonitorsMutationRequest,
  config: Partial<RequestConfig<SearchMonitorsMutationRequest>> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<SearchMonitorsMutationResponse, ResponseErrorConfig<SearchMonitors401>, SearchMonitorsMutationRequest>({
    method: 'POST',
    url: getSearchMonitorsUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
